<script setup lang="ts">
import { FindGameConsolesDocument, type FindGameConsolesQuery, type GameConsoleListItemFragment } from "../graphql/types"
import { useAsyncEntitySearch } from "../forms/composables/useAsyncEntitySearch"
import AsyncBadgeCombobox from "../forms/components/AsyncBadgeCombobox.vue"

const modelValue = defineModel<GameConsoleListItemFragment[]>({ default: () => [] })

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })

const { items, loading, hasMore, search, loadMore } = useAsyncEntitySearch<FindGameConsolesQuery, GameConsoleListItemFragment>({
  queryDocument: FindGameConsolesDocument,
  extract: (r) => r.findGameConsoles
})
</script>

<template>
  <AsyncBadgeCombobox
    v-model="modelValue"
    :items="items"
    :loading="loading"
    :has-more="hasMore"
    :search="search"
    :label-fn="(c) => c.name"
    placeholder="Spielekonsole suchen..."
    :disabled="disabled"
    @load-more="loadMore"
  />
</template>
